@if (horizontal) {
  <div class="row">
    <ng-container *ngTemplateOutlet="list"></ng-container>
  </div>
} @else {
  @if (rendering?.fields?.accompanyingText?.value) {
    <div [ngClass]="{ 'col-12 col-md-6': horizontal }">
      <wl-rich-text-wrapper
        [field]="rendering?.fields?.accompanyingText"
        [rendering]="rendering"
      >
        <div></div>
      </wl-rich-text-wrapper>
    </div>
  }
  <div [ngClass]="{ 'col-12 col-md-6': horizontal }">
    <sc-placeholder name="list-item" [rendering]="rendering"></sc-placeholder>
  </div>
}

<ng-template #list>
  @if (rendering?.fields?.accompanyingText?.value) {
    <div [ngClass]="{ 'col-12 col-md-6': horizontal }">
      <wl-rich-text-wrapper
        [field]="rendering?.fields?.accompanyingText"
        [rendering]="rendering"
      >
        <div></div>
      </wl-rich-text-wrapper>
    </div>
  }
  <div [ngClass]="{ 'col-12 col-md-6': horizontal }">
    <sc-placeholder name="list-item" [rendering]="rendering"></sc-placeholder>
  </div>
</ng-template>
